import { getIn18Text } from '@/api/utils';
export var WhatsAppMessageTypeV2;
(function (WhatsAppMessageTypeV2) {
    WhatsAppMessageTypeV2["text"] = "text";
    WhatsAppMessageTypeV2["image"] = "image";
    WhatsAppMessageTypeV2["video"] = "video";
    WhatsAppMessageTypeV2["audio"] = "audio";
    WhatsAppMessageTypeV2["sticker"] = "sticker";
    WhatsAppMessageTypeV2["document"] = "document";
    WhatsAppMessageTypeV2["location"] = "location";
    WhatsAppMessageTypeV2["template"] = "template";
})(WhatsAppMessageTypeV2 || (WhatsAppMessageTypeV2 = {}));
export var WhatsAppMessageTypeNameV2;
(function (WhatsAppMessageTypeNameV2) {
    WhatsAppMessageTypeNameV2["text"] = "\u6587\u672C";
    WhatsAppMessageTypeNameV2["image"] = "\u56FE\u7247";
    WhatsAppMessageTypeNameV2["video"] = "\u89C6\u9891";
    WhatsAppMessageTypeNameV2["audio"] = "\u97F3\u9891";
    WhatsAppMessageTypeNameV2["sticker"] = "\u8868\u60C5";
    WhatsAppMessageTypeNameV2["document"] = "\u6587\u4EF6";
    WhatsAppMessageTypeNameV2["location"] = "\u5750\u6807";
    WhatsAppMessageTypeNameV2["template"] = "\u6A21\u677F";
})(WhatsAppMessageTypeNameV2 || (WhatsAppMessageTypeNameV2 = {}));
export var WhatsAppQuotaUserType;
(function (WhatsAppQuotaUserType) {
    WhatsAppQuotaUserType[WhatsAppQuotaUserType["OFFICIAL"] = 0] = "OFFICIAL";
    WhatsAppQuotaUserType[WhatsAppQuotaUserType["TRIAL"] = 1] = "TRIAL";
})(WhatsAppQuotaUserType || (WhatsAppQuotaUserType = {}));
export var WhatsAppQuotaUserTypeName;
(function (WhatsAppQuotaUserTypeName) {
    WhatsAppQuotaUserTypeName[WhatsAppQuotaUserTypeName["\u6B63\u5F0F"] = 0] = "\u6B63\u5F0F";
    WhatsAppQuotaUserTypeName[WhatsAppQuotaUserTypeName["\u8BD5\u7528"] = 1] = "\u8BD5\u7528";
})(WhatsAppQuotaUserTypeName || (WhatsAppQuotaUserTypeName = {}));
export var WhatsAppAuthenticateState;
(function (WhatsAppAuthenticateState) {
    WhatsAppAuthenticateState[WhatsAppAuthenticateState["NOT_EXIST"] = -1] = "NOT_EXIST";
    WhatsAppAuthenticateState[WhatsAppAuthenticateState["NOT_AUTHENTICATED"] = 0] = "NOT_AUTHENTICATED";
    WhatsAppAuthenticateState[WhatsAppAuthenticateState["AUTHENTICATED"] = 1] = "AUTHENTICATED";
})(WhatsAppAuthenticateState || (WhatsAppAuthenticateState = {}));
export var WhatsAppAuthenticateStateName;
(function (WhatsAppAuthenticateStateName) {
    WhatsAppAuthenticateStateName[WhatsAppAuthenticateStateName["\u4E0D\u5B58\u5728"] = -1] = "\u4E0D\u5B58\u5728";
    WhatsAppAuthenticateStateName[WhatsAppAuthenticateStateName["\u672A\u8BA4\u8BC1"] = 0] = "\u672A\u8BA4\u8BC1";
    WhatsAppAuthenticateStateName[WhatsAppAuthenticateStateName["\u8BA4\u8BC1\u901A\u8FC7"] = 1] = "\u8BA4\u8BC1\u901A\u8FC7";
})(WhatsAppAuthenticateStateName || (WhatsAppAuthenticateStateName = {}));
export var WhatsAppMessageDirection;
(function (WhatsAppMessageDirection) {
    WhatsAppMessageDirection[WhatsAppMessageDirection["LX_TO_WHATSAPP"] = 0] = "LX_TO_WHATSAPP";
    WhatsAppMessageDirection[WhatsAppMessageDirection["WHATSAPP_TO_LX"] = 1] = "WHATSAPP_TO_LX";
})(WhatsAppMessageDirection || (WhatsAppMessageDirection = {}));
export var WhatsAppVariableType;
(function (WhatsAppVariableType) {
    WhatsAppVariableType[WhatsAppVariableType["FIXED"] = 0] = "FIXED";
    WhatsAppVariableType[WhatsAppVariableType["FILE_FIELD"] = 1] = "FILE_FIELD";
})(WhatsAppVariableType || (WhatsAppVariableType = {}));
export const getWhatsAppVariableTypeName = () => ({
    0: getIn18Text('GUDINGZHI'),
    1: getIn18Text('DAORUWENJIANZIDUAN'),
});
export var WhatsAppTemplateStatus;
(function (WhatsAppTemplateStatus) {
    WhatsAppTemplateStatus["DRAFT"] = "DRAFT";
    WhatsAppTemplateStatus["APPROVED"] = "APPROVED";
    WhatsAppTemplateStatus["IN_APPEAL"] = "IN_APPEAL";
    WhatsAppTemplateStatus["REJECTED"] = "REJECTED";
})(WhatsAppTemplateStatus || (WhatsAppTemplateStatus = {}));
export const getWhatsAppTemplateStatusName = () => ({
    DRAFT: getIn18Text('CAOGAO'),
    APPROVED: getIn18Text('YITONGGUO'),
    IN_APPEAL: getIn18Text('SHENHEZHONG'),
    REJECTED: getIn18Text('WEITONGGUO'),
});
export var WhatsAppTemplateStatusColor;
(function (WhatsAppTemplateStatusColor) {
    WhatsAppTemplateStatusColor["DRAFT"] = "rgba(38, 42, 51, 0.08)";
    WhatsAppTemplateStatusColor["APPROVED"] = "#F1FAF7";
    WhatsAppTemplateStatusColor["IN_APPEAL"] = "rgba(107, 169, 255, 0.1)";
    WhatsAppTemplateStatusColor["REJECTED"] = "rgba(247, 79, 79, 0.1)";
})(WhatsAppTemplateStatusColor || (WhatsAppTemplateStatusColor = {}));
export var WhatsAppFileExtractIndex;
(function (WhatsAppFileExtractIndex) {
    WhatsAppFileExtractIndex[WhatsAppFileExtractIndex["WHATSAPP"] = 0] = "WHATSAPP";
    WhatsAppFileExtractIndex[WhatsAppFileExtractIndex["CONTACT_NAME"] = 1] = "CONTACT_NAME";
    WhatsAppFileExtractIndex[WhatsAppFileExtractIndex["COMPANY_NAME"] = 2] = "COMPANY_NAME";
})(WhatsAppFileExtractIndex || (WhatsAppFileExtractIndex = {}));
export var WhatsAppFileExtractStatus;
(function (WhatsAppFileExtractStatus) {
    WhatsAppFileExtractStatus[WhatsAppFileExtractStatus["SUCCESS"] = 0] = "SUCCESS";
    WhatsAppFileExtractStatus[WhatsAppFileExtractStatus["REPEAT"] = 1] = "REPEAT";
    WhatsAppFileExtractStatus[WhatsAppFileExtractStatus["INVALID"] = 2] = "INVALID";
})(WhatsAppFileExtractStatus || (WhatsAppFileExtractStatus = {}));
export var WhatsAppFileExtractStatusName;
(function (WhatsAppFileExtractStatusName) {
    WhatsAppFileExtractStatusName[WhatsAppFileExtractStatusName["\u6210\u529F"] = 0] = "\u6210\u529F";
    WhatsAppFileExtractStatusName[WhatsAppFileExtractStatusName["\u91CD\u590D"] = 1] = "\u91CD\u590D";
    WhatsAppFileExtractStatusName[WhatsAppFileExtractStatusName["\u683C\u5F0F\u6709\u8BEF"] = 2] = "\u683C\u5F0F\u6709\u8BEF";
})(WhatsAppFileExtractStatusName || (WhatsAppFileExtractStatusName = {}));
export var WhatsAppMessageType;
(function (WhatsAppMessageType) {
    WhatsAppMessageType["TEXT"] = "TEXT";
    WhatsAppMessageType["DOCUMENT"] = "DOCUMENT";
    WhatsAppMessageType["IMAGE"] = "IMAGE";
    WhatsAppMessageType["VIDEO"] = "VIDEO";
    WhatsAppMessageType["LOCATION"] = "LOCATION";
    WhatsAppMessageType["STICKER"] = "STICKER";
    WhatsAppMessageType["TEMPLATE"] = "TEMPLATE";
    WhatsAppMessageType["CONTACT"] = "CONTACT";
    WhatsAppMessageType["AUDIO"] = "AUDIO";
})(WhatsAppMessageType || (WhatsAppMessageType = {}));
export var WhatsAppMessageTypeName;
(function (WhatsAppMessageTypeName) {
    WhatsAppMessageTypeName["TEXT"] = "\u6587\u672C";
    WhatsAppMessageTypeName["DOCUMENT"] = "\u6587\u4EF6";
    WhatsAppMessageTypeName["IMAGE"] = "\u56FE\u7247";
    WhatsAppMessageTypeName["VIDEO"] = "\u89C6\u9891";
    WhatsAppMessageTypeName["LOCATION"] = "\u5750\u6807";
    WhatsAppMessageTypeName["STICKER"] = "\u8868\u60C5";
    WhatsAppMessageTypeName["TEMPLATE"] = "\u6A21\u677F";
    WhatsAppMessageTypeName["CONTACT"] = "\u8054\u7CFB\u4EBA";
    WhatsAppMessageTypeName["AUDIO"] = "\u97F3\u9891";
})(WhatsAppMessageTypeName || (WhatsAppMessageTypeName = {}));
export var WhatsAppJobSubmitType;
(function (WhatsAppJobSubmitType) {
    WhatsAppJobSubmitType[WhatsAppJobSubmitType["DRAFT"] = 0] = "DRAFT";
    WhatsAppJobSubmitType[WhatsAppJobSubmitType["SUBMIT"] = 1] = "SUBMIT";
})(WhatsAppJobSubmitType || (WhatsAppJobSubmitType = {}));
export var WhatsAppJobSendType;
(function (WhatsAppJobSendType) {
    WhatsAppJobSendType[WhatsAppJobSendType["SEND_NOW"] = 0] = "SEND_NOW";
    WhatsAppJobSendType[WhatsAppJobSendType["CRON_SEND"] = 1] = "CRON_SEND";
})(WhatsAppJobSendType || (WhatsAppJobSendType = {}));
export const getWhatsAppJobSendTypeName = () => ({
    0: getIn18Text('LIJIFASONG'),
    1: getIn18Text('DINGSHIFASONG'),
});
export var WhatsAppJobState;
(function (WhatsAppJobState) {
    WhatsAppJobState[WhatsAppJobState["DRAFT"] = 0] = "DRAFT";
    WhatsAppJobState[WhatsAppJobState["TO_BE_SEND"] = 1] = "TO_BE_SEND";
    WhatsAppJobState[WhatsAppJobState["SENDING"] = 2] = "SENDING";
    WhatsAppJobState[WhatsAppJobState["SENT"] = 3] = "SENT";
    WhatsAppJobState[WhatsAppJobState["REVERT"] = 4] = "REVERT";
    WhatsAppJobState[WhatsAppJobState["FAILED"] = 5] = "FAILED";
})(WhatsAppJobState || (WhatsAppJobState = {}));
export const getWhatsAppJobStateName = () => ({
    0: getIn18Text('CAOGAO'),
    1: getIn18Text('DAIFASONG'),
    2: getIn18Text('FASONGZHONG'),
    3: getIn18Text('YIFASONG'),
    4: getIn18Text('YICHEXIAO'),
    5: getIn18Text('SHIBAI'),
});
export const WhatsAppJobStateColor = {
    0: { color: '#3081F2', backgroundColor: '#F2F7FE' },
    1: { color: '#4C6AFF', backgroundColor: '#F2F5FF' },
    2: { color: '#ED8A2F', backgroundColor: '#FFF8ED' },
    3: { color: '#00A870', backgroundColor: '#E7FBF3' },
    4: { color: '#4F4F61', backgroundColor: '#F0F3F5' },
    5: { color: '#e45244', backgroundColor: '#ffdedb' },
};
export var WhatsAppBSP;
(function (WhatsAppBSP) {
    WhatsAppBSP["IB"] = "IB";
    WhatsAppBSP["NX"] = "NX";
})(WhatsAppBSP || (WhatsAppBSP = {}));
export var WhatsAppJobReceiverSendState;
(function (WhatsAppJobReceiverSendState) {
    WhatsAppJobReceiverSendState[WhatsAppJobReceiverSendState["TO_BE_SEND"] = -1] = "TO_BE_SEND";
    WhatsAppJobReceiverSendState[WhatsAppJobReceiverSendState["SUCCESS"] = 0] = "SUCCESS";
    WhatsAppJobReceiverSendState[WhatsAppJobReceiverSendState["FAILURE"] = 1] = "FAILURE";
    WhatsAppJobReceiverSendState[WhatsAppJobReceiverSendState["REVERT"] = 2] = "REVERT";
    WhatsAppJobReceiverSendState[WhatsAppJobReceiverSendState["SENT"] = 3] = "SENT";
})(WhatsAppJobReceiverSendState || (WhatsAppJobReceiverSendState = {}));
export const getWhatsAppJobReceiverSendStateName = () => ({
    '-1': getIn18Text('DAIFASONG'),
    0: getIn18Text('CHENGGONG'),
    1: getIn18Text('SHIBAI'),
    2: getIn18Text('YICHEXIAO'),
    3: getIn18Text('FASONGZHONG'),
});
export var WhatsAppJobReceiverSendStateColor;
(function (WhatsAppJobReceiverSendStateColor) {
    WhatsAppJobReceiverSendStateColor[WhatsAppJobReceiverSendStateColor["#5FC375"] = 0] = "#5FC375";
    WhatsAppJobReceiverSendStateColor[WhatsAppJobReceiverSendStateColor["#F74F4F"] = 1] = "#F74F4F";
})(WhatsAppJobReceiverSendStateColor || (WhatsAppJobReceiverSendStateColor = {}));
export var WhatsAppJobReceiverSendStateV2;
(function (WhatsAppJobReceiverSendStateV2) {
    WhatsAppJobReceiverSendStateV2[WhatsAppJobReceiverSendStateV2["TO_BE_SEND"] = 0] = "TO_BE_SEND";
    WhatsAppJobReceiverSendStateV2[WhatsAppJobReceiverSendStateV2["SENT"] = 1] = "SENT";
    WhatsAppJobReceiverSendStateV2[WhatsAppJobReceiverSendStateV2["SUCCESS"] = 2] = "SUCCESS";
    WhatsAppJobReceiverSendStateV2[WhatsAppJobReceiverSendStateV2["FAILURE"] = 3] = "FAILURE";
    WhatsAppJobReceiverSendStateV2[WhatsAppJobReceiverSendStateV2["REVERT"] = 4] = "REVERT";
})(WhatsAppJobReceiverSendStateV2 || (WhatsAppJobReceiverSendStateV2 = {}));
export const getWhatsAppJobReceiverSendStateNameV2 = () => ({
    0: getIn18Text('DAIFASONG'),
    1: getIn18Text('FASONGZHONG'),
    2: getIn18Text('CHENGGONG'),
    3: getIn18Text('SHIBAI'),
    4: getIn18Text('YICHEXIAO'),
});
export var WhatsAppJobReceiverSendStateColorV2;
(function (WhatsAppJobReceiverSendStateColorV2) {
    WhatsAppJobReceiverSendStateColorV2[WhatsAppJobReceiverSendStateColorV2["#5FC375"] = 2] = "#5FC375";
    WhatsAppJobReceiverSendStateColorV2[WhatsAppJobReceiverSendStateColorV2["#F74F4F"] = 3] = "#F74F4F";
})(WhatsAppJobReceiverSendStateColorV2 || (WhatsAppJobReceiverSendStateColorV2 = {}));
export var WhatsAppJobReportReceiverType;
(function (WhatsAppJobReportReceiverType) {
    WhatsAppJobReportReceiverType["CUSTOMER"] = "CUSTOMER";
    WhatsAppJobReportReceiverType["OPPORTUNITY"] = "OPPORTUNITY";
    WhatsAppJobReportReceiverType["CLUE"] = "CLUE";
})(WhatsAppJobReportReceiverType || (WhatsAppJobReportReceiverType = {}));
export const getWhatsAppJobReportReceiverTypeName = () => ({
    CUSTOMER: getIn18Text('KEHU'),
    OPPORTUNITY: getIn18Text('SHANGJI'),
    CLUE: getIn18Text('XIANSUO'),
});
export var WhatsAppAiSearchTaskStatus;
(function (WhatsAppAiSearchTaskStatus) {
    WhatsAppAiSearchTaskStatus[WhatsAppAiSearchTaskStatus["SEARCHING"] = 1] = "SEARCHING";
    WhatsAppAiSearchTaskStatus[WhatsAppAiSearchTaskStatus["STOP"] = 2] = "STOP";
})(WhatsAppAiSearchTaskStatus || (WhatsAppAiSearchTaskStatus = {}));
export var WhatsAppAiSearchTag;
(function (WhatsAppAiSearchTag) {
    WhatsAppAiSearchTag["DELIVERED"] = "DELIVERED";
})(WhatsAppAiSearchTag || (WhatsAppAiSearchTag = {}));
export var WhatsAppAiSearchTagName;
(function (WhatsAppAiSearchTagName) {
    WhatsAppAiSearchTagName["DELIVERED"] = "\u89E6\u8FBE\u8FC7";
})(WhatsAppAiSearchTagName || (WhatsAppAiSearchTagName = {}));
export var WhatsAppAiSearchTagColor;
(function (WhatsAppAiSearchTagColor) {
    WhatsAppAiSearchTagColor["DELIVERED"] = "#398E80";
})(WhatsAppAiSearchTagColor || (WhatsAppAiSearchTagColor = {}));
export var WhatsAppAiSearchTagBackgroundColor;
(function (WhatsAppAiSearchTagBackgroundColor) {
    WhatsAppAiSearchTagBackgroundColor["DELIVERED"] = "#D6F7F1";
})(WhatsAppAiSearchTagBackgroundColor || (WhatsAppAiSearchTagBackgroundColor = {}));
